import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getStockorderproductList } from 'components/stockorderproduct/StockorderproductAPI';
import { setStockorderproductList, setStockorderproductDashboardStockorderproductList } from 'store/slice/ManufSlice';
import StockorderproductDashboard from '../StockorderproductDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function StockorderproductPageImpl() {
    const dispatch = useDispatch();
    const { stockorderproductList} = useSelector((state)=>state.manufslice);
    const {stockorderObj} = useSelector((state) => state.manufslice.stockorderDashboard);
    
    const getStockorderproductListSuccess = (list) =>{dispatch(setStockorderproductList(list));}
    useEffect(() => {
        getStockorderproductList(()=>{}, getStockorderproductListSuccess);
    },[]);
    useEffect(()=>{
        if (stockorderObj && stockorderObj.id) {
            dispatch(setStockorderproductDashboardStockorderproductList( 
                stockorderproductList.filter((obj) => obj.stockorderid === stockorderObj.id)));    
        } else {
            dispatch(setStockorderproductDashboardStockorderproductList([]));
        }
    },[ stockorderproductList])

    return (
        < StockorderproductDashboard />
    )

}